import { autoinject, bindable, observable } from 'aurelia-framework';
import { ValidationController, Validator } from 'aurelia-validation';
import { Models } from 'models/core';
import { ErpSystem } from 'models/ErpSystem';
import { ErpSystemService } from 'services/erp-system-service';

@autoinject
export class ProductsForm {
  @bindable
  @observable
  private product: Models.Product;

  @bindable
  protected validationController: ValidationController;

  protected erpSystems: ErpSystem[] = [];

  constructor(private erpSystemService: ErpSystemService, private validator: Validator) {
    void this.getErpSystems();
  }

  private attached() {
    console.log(this.validationController);
  }

  protected async getErpSystems() {
    const erpSystems = await this.erpSystemService.getAll();
    //Should not be able to create products for Navision and Delta, because they get imported from the ERP system
    const filteredErpSystems = erpSystems.filter((item) => item.SourceType !== 1 && item.SourceType !== 2);
    this.erpSystems = filteredErpSystems;
  }
}
